import styled from 'styled-components';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Card = styled.section`
  background: var(--surface);
  border: 1px solid var(--outline);
  border-radius: 12px;
  padding: 1rem;
`;

export const CardTitle = styled.h2`
  margin: 0 0 0.75rem;
  color: var(--onSurface);
  font-size: 1.05rem;
`;

export const Subtle = styled.p`
  margin: 0;
  color: var(--onSurfaceVariant);
  font-size: 0.9rem;
`;

export const Row = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const Metric = styled.div`
  border: 1px solid var(--outline);
  border-radius: 10px;
  padding: 0.85rem;
  background: var(--surface);
`;

export const MetricLabel = styled.div`
  color: var(--onSurfaceVariant);
  font-size: 0.8rem;
`;

export const MetricValue = styled.div`
  color: var(--primary);
  font-size: 1.35rem;
  font-weight: 700;
  margin-top: 0.25rem;
`;

export const Input = styled.input`
  min-height: 40px;
  border: 1px solid var(--outline);
  border-radius: 8px;
  padding: 0 0.75rem;
  background: var(--surface);
  color: var(--onSurface);
  min-width: 220px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  border: 1px solid var(--outline);
  border-radius: 8px;
  padding: 0.65rem 0.75rem;
  background: var(--surface);
  color: var(--onSurface);
  font-family: inherit;
`;

export const Select = styled.select`
  min-height: 40px;
  border: 1px solid var(--outline);
  border-radius: 8px;
  padding: 0 0.75rem;
  background: var(--surface);
  color: var(--onSurface);
  min-width: 220px;
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

export const Item = styled.li`
  border: 1px solid var(--outline);
  border-radius: 10px;
  padding: 0.75rem;
  background: var(--surface);
`;
